export default function () {
  return {
    'oopsz3': [{
      title: '2019夏斯坦福-硅谷创业精英培训营行前先导课',
      videoIds: [
        { name: '领导力 Leadership', id: '95f46b40-ac2d-11e9-a1ef-6bffc00148fb' },
        { name: '职业规划 Career Development', id: '79d6b210-ac2d-11e9-a1ef-6bffc00148fb' },
        { name: 'Work Relationship', id: 'd19ce750-ae92-11e9-a1ef-6bffc00148fb' },
        { name: 'Negotiation', id: 'be568430-ae92-11e9-a1ef-6bffc00148fb' }
      ]
    }],
    'lskn11': [{
      title: '启德哈佛哥大科技创新项目-行前课程',
      videoIds: [
        { name: 'Open Course Geraldine 1', id: '47529030-a83f-11e9-8922-8fa7c1e37edb' },
        { name: 'Open Course Geraldine 2', id: '63ff6a00-a83f-11e9-8922-8fa7c1e37edb' },
        { name: 'Open Course Geraldine 3', id: '76b23fb0-a83f-11e9-8922-8fa7c1e37edb' },
        { name: 'Open Course Geraldine 4', id: '8b49daf0-a83f-11e9-8922-8fa7c1e37edb' },
        { name: 'Career Development & Planning', id: 'a236fef0-a83f-11e9-8922-8fa7c1e37edb' }
      ]
    }],
    'p1lskc': [{
      title: '课程名为：2019夏 AR行前先导课',
      videoIds: [
        { name: '设计思维', id: '25769d30-97eb-11e9-a110-e1376cc6c37e' },
        { name: '游戏设计概述', id: 'c7bf6790-9c99-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 1', id: '16a612f0-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 2', id: '387fd870-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 3', id: '4e1fe300-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 4', id: '6178e3c0-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 5', id: '73943460-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 6', id: '7f1b6830-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 7', id: '9d5571b0-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 8', id: 'a65907e0-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 9', id: 'b044b420-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 10', id: 'bf4641a0-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 11', id: 'cdd425c0-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: 'Python 碎片化 Lesson 12', id: 'd6307f70-9c9a-11e9-ac77-f3a4f8eb18b8' },
        { name: '美国大学申请指导1', id: '5e24bc20-a2ef-11e9-bd5d-91249c28f993' },
        { name: '美国大学申请指导2', id: '78097540-a2ef-11e9-bd5d-91249c28f993' },
        { name: '美国大学申请指导3', id: '9aaea110-a2ef-11e9-bd5d-91249c28f993' },
        { name: '美国大学申请指导4', id: 'a3ba4d90-a2ef-11e9-bd5d-91249c28f993' }
      ]
    }],
    'olsif1': [{
      title: '2019 夏管培生行前先导课',
      videoIds: [
        { name: '设计思维', id: '25769d30-97eb-11e9-a110-e1376cc6c37e' },
        { name: '金融英语I - Introduction to Finance', id: '38e29440-97ec-11e9-a110-e1376cc6c37e' },
        { name: '金融英语II - Stock and Stock Marke', id: '56053a50-97ec-11e9-a110-e1376cc6c37e' },
        { name: '金融英语III - Bonds and othher financial products', id: 'acbfae70-97ec-11e9-a110-e1376cc6c37e' },
        { name: '金融英语IV - Investors', id: 'dbbd8ee0-97ec-11e9-a110-e1376cc6c37e' },
        { name: '可持续发展导论', id: '857615f0-97ee-11e9-a110-e1376cc6c37e' }
      ]
    }],
    'kioopq1': [{
      title: '哈佛哥大科技创新项目行前先导课—part 2',
      videoIds: [{
        name: 'Business Model Canvas',
        id: 'a274ba20-243b-11e9-98ff-5797a4a46430'
      }, {
        name: 'The Value Proposition Canvas',
        id: 'c829be00-243b-11e9-98ff-5797a4a46430'
      }]
    }],
    'sio1lk3': [{
      title: 'Python 碎片化课程',
      videoIds: [{
        name: 'Python Fragmentation-Hello World! ',
        id: '98b0a8d0-657a-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Arithmetic',
        id: 'ce3d9d00-657a-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Data Types',
        id: '04e09510-657b-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Variables',
        id: '4fcc9330-657b-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Strings',
        id: '7d33a700-657b-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Lists',
        id: 'aa36c8e0-657b-11e8-afe6-f7b28e1cc828'
      }]
    }],
    'PJmcV4B7': [{
      title: '华尔街金融投行实训课程-行前先导课',
      videoIds: [{
        name: 'Finance Part 1&2',
        id: '35325b90-7c0a-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Finance Part 3',
        id: '78cd7530-7c0d-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Finance Part 4',
        id: '4c0bd3b0-7c0e-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Finance Part 5',
        id: '2b4c9730-7c14-11e8-95fc-a1423b4f3454'
      },
      {
        name: '金融行业Excel1-1',
        id: '6fe6c9e0-7f4f-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel1-2',
        id: 'bdd559a0-7f4f-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel2-1',
        id: 'ab808d00-7f50-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel2-2',
        id: '64e28c40-7f50-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel3-1',
        id: '1ac39030-7f52-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel3-2',
        id: '81497180-7f52-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel4-1',
        id: 'dea0dc10-7f52-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel4-2',
        id: '2275aab0-7f53-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel5&6-1',
        id: '7e200180-7f53-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel5&6-2',
        id: '4cb99aa0-7f55-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel7-1',
        id: 'd414dbb0-7f53-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel7-2',
        id: '0f1b7c00-7f54-11e8-8062-1d32a87e46fd'
      },
      {
        name: 'Accounting 1',
        id: '14982990-6ee6-11e8-814f-93299ac64336'
      },
      {
        name: 'Accounting 2',
        id: 'cd942880-7b71-11e8-9579-c59190142777'
      },
      {
        name: 'Accounting 3',
        id: '5cb231a0-7b8c-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Accounting 4',
        id: 'dc14aae0-7b8c-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Accounting 5',
        id: '1b150e10-7b8d-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Accounting 6',
        id: '54cdd1a0-7b8d-11e8-95fc-a1423b4f3454'
      }
      ]
    }],
    'oopposkx': [{
      title: '加拿大Bay Street金融实训项目-行前先导课',
      videoIds: [{
        name: 'Finance Part 1&2',
        id: '35325b90-7c0a-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Finance Part 3',
        id: '78cd7530-7c0d-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Finance Part 4',
        id: '4c0bd3b0-7c0e-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Finance Part 5',
        id: '2b4c9730-7c14-11e8-95fc-a1423b4f3454'
      },
      {
        name: '金融行业Excel1-1',
        id: '6fe6c9e0-7f4f-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel1-2',
        id: 'bdd559a0-7f4f-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel2-1',
        id: 'ab808d00-7f50-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel2-2',
        id: '64e28c40-7f50-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel3-1',
        id: '1ac39030-7f52-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel3-2',
        id: '81497180-7f52-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel4-1',
        id: 'dea0dc10-7f52-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel4-2',
        id: '2275aab0-7f53-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel5&6-1',
        id: '7e200180-7f53-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Ecxel5&6-2',
        id: '4cb99aa0-7f55-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel7-1',
        id: 'd414dbb0-7f53-11e8-8062-1d32a87e46fd'
      },
      {
        name: '金融行业Excel7-2',
        id: '0f1b7c00-7f54-11e8-8062-1d32a87e46fd'
      },
      {
        name: 'Accounting 1',
        id: '14982990-6ee6-11e8-814f-93299ac64336'
      },
      {
        name: 'Accounting 2',
        id: 'cd942880-7b71-11e8-9579-c59190142777'
      },
      {
        name: 'Accounting 3',
        id: '5cb231a0-7b8c-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Accounting 4',
        id: 'dc14aae0-7b8c-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Accounting 5',
        id: '1b150e10-7b8d-11e8-95fc-a1423b4f3454'
      },
      {
        name: 'Accounting 6',
        id: '54cdd1a0-7b8d-11e8-95fc-a1423b4f3454'
      }
      ]
    }],
    'RFj7WQa': [{
      title: '哈佛哥大科技创新项目行前先导课—第一周',
      videoIds: [{
        name: 'Career Development & Planning：',
        id: '8418b640-130f-11e9-a8dc-51c256f1c5a3'
      }, {
        name: 'Top US College Application-1',
        id: '78840850-b4b1-11e8-8779-b96edc841c6a'
      }, {
        name: 'Top US College Application-2',
        id: '9b958860-4872-11e8-85ec-6d4b333ef911'
      }, {
        name: 'Top US College Application-3',
        id: 'c664da50-4872-11e8-85ec-6d4b333ef911'
      }, {
        name: 'Top US College Application-4',
        id: 'ee63ce30-4872-11e8-85ec-6d4b333ef911'
      }]
    }],
    'SGB83L2P': [{
      title: 'AR游戏设计与编程项目-先导课',
      videoIds: [{
        name: 'General Introduction to Game Design',
        id: '374d6fe0-f9ec-11e8-a427-431feecdced4'
      }, {
        name: 'Python Fragmentation 1--Hello World!',
        id: '98b0a8d0-657a-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 1--Arithmetic',
        id: 'ce3d9d00-657a-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 1--Data Types',
        id: '04e09510-657b-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 1--Variables',
        id: '4fcc9330-657b-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 1--Strings',
        id: '7d33a700-657b-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 1--Lists',
        id: 'aa36c8e0-657b-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 2--Logic - If/Else',
        id: '0eb91200-657c-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 2--Logic - And/Or',
        id: '3ab4fd10-657c-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 2--Logic - Exercise',
        id: '6c0cfa20-657c-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 2--Loops',
        id: 'b4a54440-657c-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'Python Fragmentation 2--Functions',
        id: '36a37220-13f4-11e9-9b57-bb7fc262f2c7'
      }, {
        name: 'Python Fragmentation 2--Exercise - Credit Card Validity Check',
        id: '2e4fa8d0-657d-11e8-afe6-f7b28e1cc828'
      }, {
        name: 'College Application--哈佛招生官详解如何写出美国名校青睐的个人陈述与推荐信',
        id: '65888ec0-4872-11e8-85ec-6d4b333ef911'
      }, {
        name: 'College Application--哈佛招生官详解名校录取动态 教你展示更好自我',
        id: '9b958860-4872-11e8-85ec-6d4b333ef911'
      }, {
        name: 'College Application--哈佛招生官详解名校能给学生带来的最大优势',
        id: 'c664da50-4872-11e8-85ec-6d4b333ef911'
      }, {
        name: 'College Application--哈佛招生官详解国际生申请如何更好利用自身优势',
        id: 'ee63ce30-4872-11e8-85ec-6d4b333ef911'
      }]
    }]
  }
}



// WEBPACK FOOTER //
// ./src/views/videoList/data.js